import { render } from "./ReferTicketForm.vue?vue&type=template&id=2203726a"
import script from "./ReferTicketForm.vue?vue&type=script&lang=js"
export * from "./ReferTicketForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__